/* Bez Carvings — shared behavior
   Ported from the persian-carving prototype's js/main.js. The hero
   video, scroll reveal, header hairline and gallery are unchanged in
   spirit; the gallery now reads Shopify media and the inert
   "Checkout opens soon" note is replaced by a real variant handler. */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Hero video — pick the cut for this screen: landscape on desktop,
     portrait on small screens. Without JS, or before a merchant has
     attached video in the theme editor, the poster stands in. */
  var heroVideo = document.getElementById("hero-video");
  if (heroVideo) {
    var cut = window.matchMedia("(max-width: 940px)").matches ? "portrait" : "landscape";
    var poster = heroVideo.getAttribute("data-" + cut + "-poster");
    if (poster) heroVideo.poster = poster;

    /* An ambient film is motion. When the visitor asks for less of
       it, the poster still — already the no-JS state — stands in. */
    if (!reduceMotion) {
      var src = heroVideo.getAttribute("data-" + cut + "-src");
      if (src) {
        heroVideo.src = src;
      } else {
        /* No video for this cut. Fall back to the other one rather than
           showing a bare poster, and only give up if neither is set. */
        var other = cut === "portrait" ? "landscape" : "portrait";
        var fallback = heroVideo.getAttribute("data-" + other + "-src");
        if (fallback) heroVideo.src = fallback;
      }
    }
  }

  /* Reveal on scroll */
  var revealables = document.querySelectorAll("[data-reveal]");
  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealables.forEach(function (el) { el.classList.add("revealed"); });
  } else {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -4% 0px" }
    );
    revealables.forEach(function (el) { observer.observe(el); });
  }

  /* Header hairline once the page scrolls */
  var head = document.querySelector(".site-head");
  if (head) {
    var onScroll = function () {
      head.classList.toggle("scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Menu — on narrow screens the nav folds into a panel under the
     bar. The panel's look is entirely CSS; this owns the open state
     and the four ways a menu is expected to close. */
  var toggle = document.querySelector(".nav-toggle");
  if (head && toggle) {
    var setMenu = function (open) {
      head.classList.toggle("menu-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    toggle.addEventListener("click", function () {
      setMenu(!head.classList.contains("menu-open"));
    });

    /* a link either jumps to an anchor on this page or leaves it —
       either way the panel has done its job */
    head.querySelectorAll(".site-nav a").forEach(function (link) {
      link.addEventListener("click", function () { setMenu(false); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && head.classList.contains("menu-open")) {
        setMenu(false);
        toggle.focus();
      }
    });

    document.addEventListener("click", function (e) {
      if (head.classList.contains("menu-open") && !head.contains(e.target)) {
        setMenu(false);
      }
    });

    /* turn the phone sideways past the breakpoint and the links are
       back in the bar; the header shouldn't still think it's open */
    var wide = window.matchMedia("(min-width: 561px)");
    var onWide = function (e) { if (e.matches) setMenu(false); };
    if (wide.addEventListener) wide.addEventListener("change", onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }

  /* Product gallery */
  var mainImage = document.getElementById("gallery-image");
  if (mainImage) {
    var galleryCaption = document.getElementById("gallery-caption");
    var thumbs = document.querySelectorAll(".thumb");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) {
          t.classList.remove("active");
          t.setAttribute("aria-pressed", "false");
        });
        thumb.classList.add("active");
        thumb.setAttribute("aria-pressed", "true");
        mainImage.src = thumb.getAttribute("data-src");
        if (thumb.hasAttribute("data-srcset")) {
          mainImage.srcset = thumb.getAttribute("data-srcset");
        }
        mainImage.alt = thumb.getAttribute("data-alt") || "";
        if (galleryCaption) galleryCaption.textContent = thumb.getAttribute("data-caption") || "";
      });
    });
  }

  /* Variant selection — swaps the hidden id the form posts, and keeps
     price and button state honest. Products with a single variant
     render no selector at all, so this is a no-op on those pages. */
  var form = document.querySelector("[data-product-form]");
  if (form) {
    var variantData = null;
    var dataEl = document.getElementById("variant-data");
    if (dataEl) {
      try { variantData = JSON.parse(dataEl.textContent); } catch (e) { variantData = null; }
    }

    var selects = form.querySelectorAll("[data-option-index]");
    var idField = form.querySelector("[name='id']");
    var submit = form.querySelector("[type='submit']");
    var priceEl = document.querySelector("[data-price]");

    var sync = function () {
      if (!variantData || !idField) return;

      var chosen = [];
      selects.forEach(function (s) { chosen[Number(s.getAttribute("data-option-index"))] = s.value; });

      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = "Unavailable"; }
        return;
      }

      idField.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? "Add to cart" : "Sold out";
      }
    };

    selects.forEach(function (s) { s.addEventListener("change", sync); });
  }
})();
